import { externalUsersApi as sharedApi } from '@/features/external-users/api/externalUsersApi';
import { axiosInstance } from './axiosConfig';
import type { AuditLog } from '../features/users/types/audit-log.types';

export const externalUsersApi = {
  ...sharedApi,

  // Méthodes spécifiques outil-pro :

  create: async (userData: any) => {
    const { data } = await axiosInstance.post('/external-users-v2', userData);
    return data;
  },

  update: async (id: string, userData: any) => {
    const { data } = await axiosInstance.put(`/external-users-v2/${id}`, userData);
    return data;
  },

  delete: async (id: string, reason?: string) => {
    const { data } = await axiosInstance.delete(`/external-users-v2/${id}`, {
      data: { reason },
    });
    return data;
  },

  updatePermissions: async (id: string, permissions: string[]) => {
    const { data } = await axiosInstance.put(`/external-users-v2/${id}/permissions`, {
      permissions,
    });
    return data;
  },

  promote: async (id: string) => {
    const { data } = await axiosInstance.post(`/external-users-v2/${id}/promote`);
    return data;
  },

  anonymize: async (id: string) => {
    const { data } = await axiosInstance.post(`/external-users-v2/${id}/anonymize`);
    return data;
  },

  setPassword: async (id: string, password: string) => {
    const { data } = await axiosInstance.post(`/external-users-v2/${id}/set-password`, { password });
    return data;
  },

  resendWelcomeEmail: async (id: string) => {
    const { data } = await axiosInstance.post(`/external-users-v2/${id}/resend-welcome-email`);
    return data;
  },

  getAuditLogs: async (userId: string, limit = 50) => {
    const { data } = await axiosInstance.get<AuditLog[]>(`/external-users-v2/${userId}/audit-logs`, {
      params: { limit },
    });
    return data;
  },
};
